import ereal from "./../../multimedia/designedByEReal.png";
import Image from "react-bootstrap/Image";


const RightFooter = () => {
    return <div className='lykio-support-footer'>
            <Image style={{width:'8em'}} src="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/eREAL+white3.png"/>
        </div>
}

export default RightFooter;